module.exports = __webpack_public_path__ + "static/06_Story-board.3c3ce915.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/auspost/06_Story-board.jpg
// module id = 481
// module chunks = 110568472390859